import { Dispatch, SetStateAction, useState } from 'react'
import { ShoesState } from 'src/types'
import { UseFormWatch } from 'react-hook-form'
import { usModelOfAtomsChecker } from 'src/logic'
import { emojiChecker, isInvalidPersonalData } from 'src/logic'
import { genShoesEmbroideryCells, getShoesBaseCells, getShoesColorCells } from 'src/logic/simulationSpecification/shoes'
import { useLocale } from 'src/locales/useLocale'

type CanStepFurther = {
  canSave: boolean
  canInputConsumer: boolean
  canClose: boolean
  existArribaFontNoPointColor: boolean
  existEmoji: boolean
  setIsSave: Dispatch<SetStateAction<boolean>>
}

type CompareEmailWatch = UseFormWatch<{
  mailAddress: string
  mailAddress2: string
}>

export const useShoesCanStepFurther = (state: ShoesState, isCopied: boolean, watch: CompareEmailWatch): CanStepFurther => {
  const [isSaved, setIsSave] = useState<boolean>(false)
  const watchMailAddress = watch('mailAddress')
  const watchMailAddress2 = watch('mailAddress2')
  const { t } = useLocale()
  const baseSettings = getShoesBaseCells(state)
  const colorSettings = getShoesColorCells(state)
  const existEmbroidery = state.embroideries.filter((e) => e.content.trim().length > 0).length > 0
  const embroiderySettings = existEmbroidery ? state.embroideries.map((e) => genShoesEmbroideryCells(e, t)).flat() : []
  const existInvalidPersonal = isInvalidPersonalData(state.personal)

  const existUnselectedState = [...baseSettings, ...colorSettings, ...embroiderySettings].some((y) => y.value === 'unselected')
  const existKoreanCharacterInEmbroideries = state.embroideries.some((e) => e.content.charCodeAt(0) >= 40001 && !emojiChecker(e.content))
  const isInValidMailAddress = watchMailAddress !== watchMailAddress2 || [watchMailAddress, watchMailAddress2].some((x) => x.length === 0)
  const existArribaFontNoPointColor = state.embroideries.some((e) => e.typeFace.value === 'arriba' && !e.pointColor) // only YSR

  const existEmoji = state.embroideries.map((e) => e.content).some(emojiChecker) && !usModelOfAtomsChecker(state.baseModel.productNumber)
  const canInputConsumer = ![existUnselectedState, existKoreanCharacterInEmbroideries, existArribaFontNoPointColor].includes(true)
  const canSave = [existInvalidPersonal, isSaved, isInValidMailAddress, existEmoji].every((b) => b === false)
  const canClose = (isSaved && isCopied) || (!isSaved && !isCopied)

  return {
    canSave,
    canInputConsumer,
    canClose,
    existArribaFontNoPointColor,
    existEmoji,
    setIsSave
  }
}
